"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
var typography_1 = require("./typography");
Object.defineProperty(exports, "typography", { enumerable: true, get: function () { return typography_1.typography; } });
//# sourceMappingURL=index.js.map